import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const gridColFn = /* @__PURE__ */ createRecipe('grid-col', {}, [
  {
    "colSpan": "1",
    "colStart": "2",
    "css": {
      "gridColumnEnd": "3"
    }
  },
  {
    "colSpan": "1",
    "colStart": "3",
    "css": {
      "gridColumnEnd": "4"
    }
  },
  {
    "colSpan": "1",
    "colStart": "4",
    "css": {
      "gridColumnEnd": "5"
    }
  },
  {
    "colSpan": "1",
    "colStart": "5",
    "css": {
      "gridColumnEnd": "6"
    }
  },
  {
    "colSpan": "1",
    "colStart": "6",
    "css": {
      "gridColumnEnd": "7"
    }
  },
  {
    "colSpan": "1",
    "colStart": "7",
    "css": {
      "gridColumnEnd": "8"
    }
  },
  {
    "colSpan": "1",
    "colStart": "8",
    "css": {
      "gridColumnEnd": "9"
    }
  },
  {
    "colSpan": "1",
    "colStart": "9",
    "css": {
      "gridColumnEnd": "10"
    }
  },
  {
    "colSpan": "1",
    "colStart": "10",
    "css": {
      "gridColumnEnd": "11"
    }
  },
  {
    "colSpan": "1",
    "colStart": "11",
    "css": {
      "gridColumnEnd": "12"
    }
  },
  {
    "colSpan": "1",
    "colStart": "12",
    "css": {
      "gridColumnEnd": "13"
    }
  },
  {
    "colSpan": "2",
    "colStart": "2",
    "css": {
      "gridColumnEnd": "4"
    }
  },
  {
    "colSpan": "2",
    "colStart": "3",
    "css": {
      "gridColumnEnd": "5"
    }
  },
  {
    "colSpan": "2",
    "colStart": "4",
    "css": {
      "gridColumnEnd": "6"
    }
  },
  {
    "colSpan": "2",
    "colStart": "5",
    "css": {
      "gridColumnEnd": "7"
    }
  },
  {
    "colSpan": "2",
    "colStart": "6",
    "css": {
      "gridColumnEnd": "8"
    }
  },
  {
    "colSpan": "2",
    "colStart": "7",
    "css": {
      "gridColumnEnd": "9"
    }
  },
  {
    "colSpan": "2",
    "colStart": "8",
    "css": {
      "gridColumnEnd": "10"
    }
  },
  {
    "colSpan": "2",
    "colStart": "9",
    "css": {
      "gridColumnEnd": "11"
    }
  },
  {
    "colSpan": "2",
    "colStart": "10",
    "css": {
      "gridColumnEnd": "12"
    }
  },
  {
    "colSpan": "2",
    "colStart": "11",
    "css": {
      "gridColumnEnd": "13"
    }
  },
  {
    "colSpan": "3",
    "colStart": "2",
    "css": {
      "gridColumnEnd": "5"
    }
  },
  {
    "colSpan": "3",
    "colStart": "3",
    "css": {
      "gridColumnEnd": "6"
    }
  },
  {
    "colSpan": "3",
    "colStart": "4",
    "css": {
      "gridColumnEnd": "7"
    }
  },
  {
    "colSpan": "3",
    "colStart": "5",
    "css": {
      "gridColumnEnd": "8"
    }
  },
  {
    "colSpan": "3",
    "colStart": "6",
    "css": {
      "gridColumnEnd": "9"
    }
  },
  {
    "colSpan": "3",
    "colStart": "7",
    "css": {
      "gridColumnEnd": "10"
    }
  },
  {
    "colSpan": "3",
    "colStart": "8",
    "css": {
      "gridColumnEnd": "11"
    }
  },
  {
    "colSpan": "3",
    "colStart": "9",
    "css": {
      "gridColumnEnd": "12"
    }
  },
  {
    "colSpan": "3",
    "colStart": "10",
    "css": {
      "gridColumnEnd": "13"
    }
  },
  {
    "colSpan": "4",
    "colStart": "2",
    "css": {
      "gridColumnEnd": "6"
    }
  },
  {
    "colSpan": "4",
    "colStart": "3",
    "css": {
      "gridColumnEnd": "7"
    }
  },
  {
    "colSpan": "4",
    "colStart": "4",
    "css": {
      "gridColumnEnd": "8"
    }
  },
  {
    "colSpan": "4",
    "colStart": "5",
    "css": {
      "gridColumnEnd": "9"
    }
  },
  {
    "colSpan": "4",
    "colStart": "6",
    "css": {
      "gridColumnEnd": "10"
    }
  },
  {
    "colSpan": "4",
    "colStart": "7",
    "css": {
      "gridColumnEnd": "11"
    }
  },
  {
    "colSpan": "4",
    "colStart": "8",
    "css": {
      "gridColumnEnd": "12"
    }
  },
  {
    "colSpan": "4",
    "colStart": "9",
    "css": {
      "gridColumnEnd": "13"
    }
  },
  {
    "colSpan": "5",
    "colStart": "2",
    "css": {
      "gridColumnEnd": "7"
    }
  },
  {
    "colSpan": "5",
    "colStart": "3",
    "css": {
      "gridColumnEnd": "8"
    }
  },
  {
    "colSpan": "5",
    "colStart": "4",
    "css": {
      "gridColumnEnd": "9"
    }
  },
  {
    "colSpan": "5",
    "colStart": "5",
    "css": {
      "gridColumnEnd": "10"
    }
  },
  {
    "colSpan": "5",
    "colStart": "6",
    "css": {
      "gridColumnEnd": "11"
    }
  },
  {
    "colSpan": "5",
    "colStart": "7",
    "css": {
      "gridColumnEnd": "12"
    }
  },
  {
    "colSpan": "5",
    "colStart": "8",
    "css": {
      "gridColumnEnd": "13"
    }
  },
  {
    "colSpan": "6",
    "colStart": "2",
    "css": {
      "gridColumnEnd": "8"
    }
  },
  {
    "colSpan": "6",
    "colStart": "3",
    "css": {
      "gridColumnEnd": "9"
    }
  },
  {
    "colSpan": "6",
    "colStart": "4",
    "css": {
      "gridColumnEnd": "10"
    }
  },
  {
    "colSpan": "6",
    "colStart": "5",
    "css": {
      "gridColumnEnd": "11"
    }
  },
  {
    "colSpan": "6",
    "colStart": "6",
    "css": {
      "gridColumnEnd": "12"
    }
  },
  {
    "colSpan": "6",
    "colStart": "7",
    "css": {
      "gridColumnEnd": "13"
    }
  },
  {
    "colSpan": "7",
    "colStart": "2",
    "css": {
      "gridColumnEnd": "9"
    }
  },
  {
    "colSpan": "7",
    "colStart": "3",
    "css": {
      "gridColumnEnd": "10"
    }
  },
  {
    "colSpan": "7",
    "colStart": "4",
    "css": {
      "gridColumnEnd": "11"
    }
  },
  {
    "colSpan": "7",
    "colStart": "5",
    "css": {
      "gridColumnEnd": "12"
    }
  },
  {
    "colSpan": "7",
    "colStart": "6",
    "css": {
      "gridColumnEnd": "13"
    }
  },
  {
    "colSpan": "8",
    "colStart": "2",
    "css": {
      "gridColumnEnd": "10"
    }
  },
  {
    "colSpan": "8",
    "colStart": "3",
    "css": {
      "gridColumnEnd": "11"
    }
  },
  {
    "colSpan": "8",
    "colStart": "4",
    "css": {
      "gridColumnEnd": "12"
    }
  },
  {
    "colSpan": "8",
    "colStart": "5",
    "css": {
      "gridColumnEnd": "13"
    }
  },
  {
    "colSpan": "9",
    "colStart": "2",
    "css": {
      "gridColumnEnd": "11"
    }
  },
  {
    "colSpan": "9",
    "colStart": "3",
    "css": {
      "gridColumnEnd": "12"
    }
  },
  {
    "colSpan": "9",
    "colStart": "4",
    "css": {
      "gridColumnEnd": "13"
    }
  },
  {
    "colSpan": "10",
    "colStart": "2",
    "css": {
      "gridColumnEnd": "12"
    }
  },
  {
    "colSpan": "10",
    "colStart": "3",
    "css": {
      "gridColumnEnd": "13"
    }
  },
  {
    "colSpan": "11",
    "colStart": "2",
    "css": {
      "gridColumnEnd": "13"
    }
  },
  {
    "colSpanS": "1",
    "colStartS": "2",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "3"
      }
    }
  },
  {
    "colSpanS": "1",
    "colStartS": "3",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "4"
      }
    }
  },
  {
    "colSpanS": "1",
    "colStartS": "4",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "5"
      }
    }
  },
  {
    "colSpanS": "1",
    "colStartS": "5",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "6"
      }
    }
  },
  {
    "colSpanS": "1",
    "colStartS": "6",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "7"
      }
    }
  },
  {
    "colSpanS": "1",
    "colStartS": "7",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "8"
      }
    }
  },
  {
    "colSpanS": "1",
    "colStartS": "8",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanS": "1",
    "colStartS": "9",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanS": "1",
    "colStartS": "10",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanS": "1",
    "colStartS": "11",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanS": "1",
    "colStartS": "12",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanS": "2",
    "colStartS": "2",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "4"
      }
    }
  },
  {
    "colSpanS": "2",
    "colStartS": "3",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "5"
      }
    }
  },
  {
    "colSpanS": "2",
    "colStartS": "4",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "6"
      }
    }
  },
  {
    "colSpanS": "2",
    "colStartS": "5",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "7"
      }
    }
  },
  {
    "colSpanS": "2",
    "colStartS": "6",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "8"
      }
    }
  },
  {
    "colSpanS": "2",
    "colStartS": "7",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanS": "2",
    "colStartS": "8",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanS": "2",
    "colStartS": "9",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanS": "2",
    "colStartS": "10",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanS": "2",
    "colStartS": "11",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanS": "3",
    "colStartS": "2",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "5"
      }
    }
  },
  {
    "colSpanS": "3",
    "colStartS": "3",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "6"
      }
    }
  },
  {
    "colSpanS": "3",
    "colStartS": "4",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "7"
      }
    }
  },
  {
    "colSpanS": "3",
    "colStartS": "5",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "8"
      }
    }
  },
  {
    "colSpanS": "3",
    "colStartS": "6",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanS": "3",
    "colStartS": "7",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanS": "3",
    "colStartS": "8",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanS": "3",
    "colStartS": "9",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanS": "3",
    "colStartS": "10",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanS": "4",
    "colStartS": "2",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "6"
      }
    }
  },
  {
    "colSpanS": "4",
    "colStartS": "3",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "7"
      }
    }
  },
  {
    "colSpanS": "4",
    "colStartS": "4",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "8"
      }
    }
  },
  {
    "colSpanS": "4",
    "colStartS": "5",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanS": "4",
    "colStartS": "6",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanS": "4",
    "colStartS": "7",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanS": "4",
    "colStartS": "8",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanS": "4",
    "colStartS": "9",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanS": "5",
    "colStartS": "2",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "7"
      }
    }
  },
  {
    "colSpanS": "5",
    "colStartS": "3",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "8"
      }
    }
  },
  {
    "colSpanS": "5",
    "colStartS": "4",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanS": "5",
    "colStartS": "5",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanS": "5",
    "colStartS": "6",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanS": "5",
    "colStartS": "7",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanS": "5",
    "colStartS": "8",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanS": "6",
    "colStartS": "2",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "8"
      }
    }
  },
  {
    "colSpanS": "6",
    "colStartS": "3",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanS": "6",
    "colStartS": "4",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanS": "6",
    "colStartS": "5",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanS": "6",
    "colStartS": "6",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanS": "6",
    "colStartS": "7",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanS": "7",
    "colStartS": "2",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanS": "7",
    "colStartS": "3",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanS": "7",
    "colStartS": "4",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanS": "7",
    "colStartS": "5",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanS": "7",
    "colStartS": "6",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanS": "8",
    "colStartS": "2",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanS": "8",
    "colStartS": "3",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanS": "8",
    "colStartS": "4",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanS": "8",
    "colStartS": "5",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanS": "9",
    "colStartS": "2",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanS": "9",
    "colStartS": "3",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanS": "9",
    "colStartS": "4",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanS": "10",
    "colStartS": "2",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanS": "10",
    "colStartS": "3",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanS": "11",
    "colStartS": "2",
    "css": {
      "_toTablet": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanM": "1",
    "colStartM": "2",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "3"
      }
    }
  },
  {
    "colSpanM": "1",
    "colStartM": "3",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "4"
      }
    }
  },
  {
    "colSpanM": "1",
    "colStartM": "4",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "5"
      }
    }
  },
  {
    "colSpanM": "1",
    "colStartM": "5",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "6"
      }
    }
  },
  {
    "colSpanM": "1",
    "colStartM": "6",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "7"
      }
    }
  },
  {
    "colSpanM": "1",
    "colStartM": "7",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "8"
      }
    }
  },
  {
    "colSpanM": "1",
    "colStartM": "8",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanM": "1",
    "colStartM": "9",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanM": "1",
    "colStartM": "10",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanM": "1",
    "colStartM": "11",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanM": "1",
    "colStartM": "12",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanM": "2",
    "colStartM": "2",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "4"
      }
    }
  },
  {
    "colSpanM": "2",
    "colStartM": "3",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "5"
      }
    }
  },
  {
    "colSpanM": "2",
    "colStartM": "4",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "6"
      }
    }
  },
  {
    "colSpanM": "2",
    "colStartM": "5",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "7"
      }
    }
  },
  {
    "colSpanM": "2",
    "colStartM": "6",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "8"
      }
    }
  },
  {
    "colSpanM": "2",
    "colStartM": "7",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanM": "2",
    "colStartM": "8",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanM": "2",
    "colStartM": "9",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanM": "2",
    "colStartM": "10",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanM": "2",
    "colStartM": "11",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanM": "3",
    "colStartM": "2",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "5"
      }
    }
  },
  {
    "colSpanM": "3",
    "colStartM": "3",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "6"
      }
    }
  },
  {
    "colSpanM": "3",
    "colStartM": "4",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "7"
      }
    }
  },
  {
    "colSpanM": "3",
    "colStartM": "5",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "8"
      }
    }
  },
  {
    "colSpanM": "3",
    "colStartM": "6",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanM": "3",
    "colStartM": "7",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanM": "3",
    "colStartM": "8",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanM": "3",
    "colStartM": "9",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanM": "3",
    "colStartM": "10",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanM": "4",
    "colStartM": "2",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "6"
      }
    }
  },
  {
    "colSpanM": "4",
    "colStartM": "3",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "7"
      }
    }
  },
  {
    "colSpanM": "4",
    "colStartM": "4",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "8"
      }
    }
  },
  {
    "colSpanM": "4",
    "colStartM": "5",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanM": "4",
    "colStartM": "6",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanM": "4",
    "colStartM": "7",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanM": "4",
    "colStartM": "8",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanM": "4",
    "colStartM": "9",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanM": "5",
    "colStartM": "2",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "7"
      }
    }
  },
  {
    "colSpanM": "5",
    "colStartM": "3",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "8"
      }
    }
  },
  {
    "colSpanM": "5",
    "colStartM": "4",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanM": "5",
    "colStartM": "5",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanM": "5",
    "colStartM": "6",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanM": "5",
    "colStartM": "7",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanM": "5",
    "colStartM": "8",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanM": "6",
    "colStartM": "2",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "8"
      }
    }
  },
  {
    "colSpanM": "6",
    "colStartM": "3",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanM": "6",
    "colStartM": "4",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanM": "6",
    "colStartM": "5",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanM": "6",
    "colStartM": "6",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanM": "6",
    "colStartM": "7",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanM": "7",
    "colStartM": "2",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanM": "7",
    "colStartM": "3",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanM": "7",
    "colStartM": "4",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanM": "7",
    "colStartM": "5",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanM": "7",
    "colStartM": "6",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanM": "8",
    "colStartM": "2",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanM": "8",
    "colStartM": "3",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanM": "8",
    "colStartM": "4",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanM": "8",
    "colStartM": "5",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanM": "9",
    "colStartM": "2",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanM": "9",
    "colStartM": "3",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanM": "9",
    "colStartM": "4",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanM": "10",
    "colStartM": "2",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanM": "10",
    "colStartM": "3",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanM": "11",
    "colStartM": "2",
    "css": {
      "tabletToLaptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanL": "1",
    "colStartL": "2",
    "css": {
      "laptop": {
        "gridColumnEnd": "3"
      }
    }
  },
  {
    "colSpanL": "1",
    "colStartL": "3",
    "css": {
      "laptop": {
        "gridColumnEnd": "4"
      }
    }
  },
  {
    "colSpanL": "1",
    "colStartL": "4",
    "css": {
      "laptop": {
        "gridColumnEnd": "5"
      }
    }
  },
  {
    "colSpanL": "1",
    "colStartL": "5",
    "css": {
      "laptop": {
        "gridColumnEnd": "6"
      }
    }
  },
  {
    "colSpanL": "1",
    "colStartL": "6",
    "css": {
      "laptop": {
        "gridColumnEnd": "7"
      }
    }
  },
  {
    "colSpanL": "1",
    "colStartL": "7",
    "css": {
      "laptop": {
        "gridColumnEnd": "8"
      }
    }
  },
  {
    "colSpanL": "1",
    "colStartL": "8",
    "css": {
      "laptop": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanL": "1",
    "colStartL": "9",
    "css": {
      "laptop": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanL": "1",
    "colStartL": "10",
    "css": {
      "laptop": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanL": "1",
    "colStartL": "11",
    "css": {
      "laptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanL": "1",
    "colStartL": "12",
    "css": {
      "laptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanL": "2",
    "colStartL": "2",
    "css": {
      "laptop": {
        "gridColumnEnd": "4"
      }
    }
  },
  {
    "colSpanL": "2",
    "colStartL": "3",
    "css": {
      "laptop": {
        "gridColumnEnd": "5"
      }
    }
  },
  {
    "colSpanL": "2",
    "colStartL": "4",
    "css": {
      "laptop": {
        "gridColumnEnd": "6"
      }
    }
  },
  {
    "colSpanL": "2",
    "colStartL": "5",
    "css": {
      "laptop": {
        "gridColumnEnd": "7"
      }
    }
  },
  {
    "colSpanL": "2",
    "colStartL": "6",
    "css": {
      "laptop": {
        "gridColumnEnd": "8"
      }
    }
  },
  {
    "colSpanL": "2",
    "colStartL": "7",
    "css": {
      "laptop": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanL": "2",
    "colStartL": "8",
    "css": {
      "laptop": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanL": "2",
    "colStartL": "9",
    "css": {
      "laptop": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanL": "2",
    "colStartL": "10",
    "css": {
      "laptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanL": "2",
    "colStartL": "11",
    "css": {
      "laptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanL": "3",
    "colStartL": "2",
    "css": {
      "laptop": {
        "gridColumnEnd": "5"
      }
    }
  },
  {
    "colSpanL": "3",
    "colStartL": "3",
    "css": {
      "laptop": {
        "gridColumnEnd": "6"
      }
    }
  },
  {
    "colSpanL": "3",
    "colStartL": "4",
    "css": {
      "laptop": {
        "gridColumnEnd": "7"
      }
    }
  },
  {
    "colSpanL": "3",
    "colStartL": "5",
    "css": {
      "laptop": {
        "gridColumnEnd": "8"
      }
    }
  },
  {
    "colSpanL": "3",
    "colStartL": "6",
    "css": {
      "laptop": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanL": "3",
    "colStartL": "7",
    "css": {
      "laptop": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanL": "3",
    "colStartL": "8",
    "css": {
      "laptop": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanL": "3",
    "colStartL": "9",
    "css": {
      "laptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanL": "3",
    "colStartL": "10",
    "css": {
      "laptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanL": "4",
    "colStartL": "2",
    "css": {
      "laptop": {
        "gridColumnEnd": "6"
      }
    }
  },
  {
    "colSpanL": "4",
    "colStartL": "3",
    "css": {
      "laptop": {
        "gridColumnEnd": "7"
      }
    }
  },
  {
    "colSpanL": "4",
    "colStartL": "4",
    "css": {
      "laptop": {
        "gridColumnEnd": "8"
      }
    }
  },
  {
    "colSpanL": "4",
    "colStartL": "5",
    "css": {
      "laptop": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanL": "4",
    "colStartL": "6",
    "css": {
      "laptop": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanL": "4",
    "colStartL": "7",
    "css": {
      "laptop": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanL": "4",
    "colStartL": "8",
    "css": {
      "laptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanL": "4",
    "colStartL": "9",
    "css": {
      "laptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanL": "5",
    "colStartL": "2",
    "css": {
      "laptop": {
        "gridColumnEnd": "7"
      }
    }
  },
  {
    "colSpanL": "5",
    "colStartL": "3",
    "css": {
      "laptop": {
        "gridColumnEnd": "8"
      }
    }
  },
  {
    "colSpanL": "5",
    "colStartL": "4",
    "css": {
      "laptop": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanL": "5",
    "colStartL": "5",
    "css": {
      "laptop": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanL": "5",
    "colStartL": "6",
    "css": {
      "laptop": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanL": "5",
    "colStartL": "7",
    "css": {
      "laptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanL": "5",
    "colStartL": "8",
    "css": {
      "laptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanL": "6",
    "colStartL": "2",
    "css": {
      "laptop": {
        "gridColumnEnd": "8"
      }
    }
  },
  {
    "colSpanL": "6",
    "colStartL": "3",
    "css": {
      "laptop": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanL": "6",
    "colStartL": "4",
    "css": {
      "laptop": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanL": "6",
    "colStartL": "5",
    "css": {
      "laptop": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanL": "6",
    "colStartL": "6",
    "css": {
      "laptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanL": "6",
    "colStartL": "7",
    "css": {
      "laptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanL": "7",
    "colStartL": "2",
    "css": {
      "laptop": {
        "gridColumnEnd": "9"
      }
    }
  },
  {
    "colSpanL": "7",
    "colStartL": "3",
    "css": {
      "laptop": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanL": "7",
    "colStartL": "4",
    "css": {
      "laptop": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanL": "7",
    "colStartL": "5",
    "css": {
      "laptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanL": "7",
    "colStartL": "6",
    "css": {
      "laptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanL": "8",
    "colStartL": "2",
    "css": {
      "laptop": {
        "gridColumnEnd": "10"
      }
    }
  },
  {
    "colSpanL": "8",
    "colStartL": "3",
    "css": {
      "laptop": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanL": "8",
    "colStartL": "4",
    "css": {
      "laptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanL": "8",
    "colStartL": "5",
    "css": {
      "laptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanL": "9",
    "colStartL": "2",
    "css": {
      "laptop": {
        "gridColumnEnd": "11"
      }
    }
  },
  {
    "colSpanL": "9",
    "colStartL": "3",
    "css": {
      "laptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanL": "9",
    "colStartL": "4",
    "css": {
      "laptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanL": "10",
    "colStartL": "2",
    "css": {
      "laptop": {
        "gridColumnEnd": "12"
      }
    }
  },
  {
    "colSpanL": "10",
    "colStartL": "3",
    "css": {
      "laptop": {
        "gridColumnEnd": "13"
      }
    }
  },
  {
    "colSpanL": "11",
    "colStartL": "2",
    "css": {
      "laptop": {
        "gridColumnEnd": "13"
      }
    }
  }
])

const gridColVariantMap = {
  "colSpan": [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12"
  ],
  "colSpanS": [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12"
  ],
  "colSpanM": [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12"
  ],
  "colSpanL": [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12"
  ],
  "colStart": [
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12"
  ],
  "colStartS": [
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12"
  ],
  "colStartM": [
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12"
  ],
  "colStartL": [
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12"
  ],
  "hAlign": [
    "start",
    "center",
    "end",
    "stretch"
  ],
  "hAlignS": [
    "start",
    "center",
    "end",
    "stretch"
  ],
  "hAlignM": [
    "start",
    "center",
    "end",
    "stretch"
  ],
  "hAlignL": [
    "start",
    "center",
    "end",
    "stretch"
  ],
  "vAlign": [
    "start",
    "center",
    "end",
    "stretch"
  ],
  "vAlignS": [
    "start",
    "center",
    "end",
    "stretch"
  ],
  "vAlignM": [
    "start",
    "center",
    "end",
    "stretch"
  ],
  "vAlignL": [
    "start",
    "center",
    "end",
    "stretch"
  ]
}

const gridColVariantKeys = Object.keys(gridColVariantMap)

export const gridCol = /* @__PURE__ */ Object.assign(memo(gridColFn.recipeFn), {
  __recipe__: true,
  __name__: 'gridCol',
  __getCompoundVariantCss__: gridColFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: gridColVariantKeys,
  variantMap: gridColVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, gridColVariantKeys)
  },
  getVariantProps: gridColFn.getVariantProps,
})